<div class="flex-control flex-column">
  <app-tabs>
    <li (click)="tabs_service.deactivate_tab()" [class.active]="!tabs_service.is_active()">All</li>
  </app-tabs>
  <app-announcements-filter class="flex-control flex-column" [hidden]="tabs_service.is_active()"></app-announcements-filter>
</div>
